import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BehaviorSubject, map, Observable, retry } from 'rxjs';
import { UserPermissions } from 'src/app/model/user-permissions';
import * as Constant from '../../utils/constant';
import { AcpIndexDBService } from '../indexed-db/acp-index-db.service';
import { Subscription, finalize, interval } from 'rxjs';
import { GetUserpoolService } from '../userpool/get-userpool.service';

@Injectable({
  providedIn: 'root'
})
export class WebSecurityMatrixService {
  public modules = []
  public permissions = []
  public app_user

  public default_permission:any = {
    download: 0,
    upload: 0,
    update: 0,
    insert: 0,
    view: 0,
  }
  constructor(
    private http:HttpService,
    public indexDBService: AcpIndexDBService,
    private getPool: GetUserpoolService
  ) {
    this.app_user = JSON.parse(localStorage.getItem('app_user'));
    const storedModules = localStorage.getItem('web_modules');
    if(storedModules) {
      this.modules = JSON.parse(storedModules)
    }
  }

  hasPermission(module_code: string): boolean{
    return this.modules.includes(module_code)
  }

  async getModulePermission(module_code: string) {
    if (!(this.app_user && Object.keys(this.app_user).length > 1)) {
      await this.getAppUser();
    }
    const storedPermissions = await this.indexDBService.getDecryptedAesEntries('web_permissions', this.app_user.id, 'permissions')
    if (storedPermissions.length > 0) {
      this.permissions =storedPermissions
    }
    const permission = this.permissions.find(item => item.module_code === module_code);
    return permission? permission.permissions : this.default_permission
  }

  async getAppUser() {
    return new Promise((resolve, reject) => {
      this.getPool.getAppUser().pipe(retry(2)).subscribe({
        next: (res: any) => {
          localStorage.setItem('app_user', JSON.stringify(res.data));
          this.app_user = res.data;
          resolve(this.app_user);
        },
        error: (err) => reject(err)
      });
    });
  }
  

  public getPermissions(cognito_username: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("cognito_username", cognito_username);
    
    return this.http.get<any>(Constant.Path.USER_PERMISSIONS.GET_USER_PERMISSIONS + "?" + queryParams);
  }

  public getWebMatrixPermission():  Observable<any>{
    return this.http.get(Constant.Path.USER_PERMISSIONS.GET_WEB_MATRIX_PERMISSIONS)
  }

  async getPermissionRecord(module_code: string): Promise<Record<string, boolean>>{
    const perm=  await this.getModulePermission(module_code)
    if (this.permissions.length > 0) 
    return {
      download: perm?.download !== 0,
      insert: perm?.insert !== 0,
      update: perm?.update !== 0,
      upload: perm?.upload !== 0,
      view: perm?.view !== 0
    };
  }

}
